import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionForm_Actor_Update_Mutation = graphql(`
  mutation MissionForm_Actor_Update(
    $actorId: Id!
    $actorableId: Id!
    $list: ActorListEnum!
    $update: ActorUnionInput!
    $versionData: VersionDataInput
  ) {
    updateMissionActor(
      actorId: $actorId
      actorableId: $actorableId
      list: $list
      update: $update
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useUpdateMissionActorMutation = () =>
  useGraphQLMutation(MissionForm_Actor_Update_Mutation);
